import { useContext } from "react";
import { CurrencyContext } from "../contexts/CurrencyContext";

const useCurrency = () => {
    const currencyContext = useContext(CurrencyContext);

    return currencyContext;
}

export default useCurrency;